import { displayToast } from '../toastify/toastify';
import addDelegateListener from '../utility-functions/add-delegate-event-listener';
import { decreaseQuantityBasket, increaseQuantityBasket, removeFromBag } from './bag-services';

const BASKET_LINE_INCREASE_SELECTOR = ".js-basket-item-increase";
const BASKET_LINE_DECREASE_SELECTOR = ".js-basket-item-decrease";
const BASKET_LINE_REMOVE_SELECTOR = ".js-basket-item-remove";
const BASKET_LINE_DATA_ID_SELECTOR = "data-basketLineId";

export default () => {
    addDelegateListener(document, 'click', BASKET_LINE_INCREASE_SELECTOR, async e => {
        e.originalEvent.preventDefault();
        const basketLineID = parseInt(e.delegateTarget.getAttribute(BASKET_LINE_DATA_ID_SELECTOR));

        var response = await increaseQuantityBasket(basketLineID);

        if (response.success) {
            location.reload();
        } else
            displayToast(getError(response));
    });

    addDelegateListener(document, 'click', BASKET_LINE_DECREASE_SELECTOR, async e => {
        e.originalEvent.preventDefault();
        const basketLineID = parseInt(e.delegateTarget.getAttribute(BASKET_LINE_DATA_ID_SELECTOR));
        var response = await decreaseQuantityBasket(basketLineID);
        if (response.success) {
            location.reload();
        } else
            displayToast(getError(response));
    });

    addDelegateListener(document, 'click', BASKET_LINE_REMOVE_SELECTOR, async e => {
        e.originalEvent.preventDefault();
        const basketLineID = parseInt(e.delegateTarget.getAttribute(BASKET_LINE_DATA_ID_SELECTOR));
        var response = await removeFromBag(basketLineID);
        if (response.success) {
            location.reload();
        } else
            displayToast(getError(response));
    });

};

const getError = (response) => {
    var errMessage = "";
    var code = response.errors[0].code;
    var desc = response.errors[0].description;
    if (code)
        errMessage += code;
    if (desc)
        errMessage += desc;
    if (!(errMessage.length > 0))
        errMessage = "An error has occured. Please contact support.";
    return errMessage;
};